import React from "react";
import { Eye } from "lucide-react";
import useGetMetricLogs from "../../hooks/useGetMetricLogs";

import Graph from "../graph";
import LoadingSpinner from "../components/LoadingSpinner";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { Button } from "components/ui/button";

function WarningAlert({ error }) {
    return (
        <div className="rounded-md border border-warning/40 bg-warning/10 px-3 py-2 text-sm text-warning">
            <strong>Warning!</strong> {error}
        </div>
    );
}

function EmptyComponent() {
    return (
        <div className="text-sm text-muted-foreground">
            <strong>No data found!</strong>
        </div>
    );
}

function MetricCard({ metricName, eventId, environment, startTime, endTime, chartHeight, openDetails, CardTitle: cardTitle }) {
    const { metricLogs, error, isLoaded } = useGetMetricLogs(
        metricName,
        eventId,
        environment,
        startTime,
        endTime
    );

    const handleDetailsViewClick = () => {
        openDetails("metric", cardTitle, metricLogs);
    };

    let cardBodyContent;
    if (isLoaded) {
        if (metricLogs.length === 0 || metricLogs["log_data"].length === 0) {
            cardBodyContent = <EmptyComponent />;
        } else {
            cardBodyContent = (
                <Graph
                    log_data={metricLogs["log_data"]}
                    key_list={metricLogs["key_list"]}
                    legend_enabled={true}
                    height={chartHeight}
                />
            );
        }
    } else if (error) {
        cardBodyContent = <WarningAlert error={error} />;
    } else {
        cardBodyContent = <LoadingSpinner />;
    }

    return (
        <Card>
            <CardHeader className="flex-row items-center justify-between space-y-0 border-b border-border py-3">
                <CardTitle className="text-sm">{cardTitle}</CardTitle>
                <Button
                    size="icon-sm"
                    onClick={handleDetailsViewClick}
                    title="View details"
                    disabled={!isLoaded}
                >
                    <Eye />
                </Button>
            </CardHeader>
            <CardContent className="flex min-h-[120px] items-center justify-center pt-4 text-center">
                <div className="w-full">{cardBodyContent}</div>
            </CardContent>
        </Card>
    );
}

export default MetricCard;
